<template>
    <div style="display: flex; align-items: center;">
      <canvas
        ref="captchaCanvas"
        :width="width"
        :height="height"
        class="captcha-canvas"
        @click="refreshCaptcha"
      ></canvas>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      width: {
        type: Number,
        default: 120, // 默认宽度
      },
      height: {
        type: Number,
        default: 36, // 默认高度
      },
    },
    data() {
      return {
        captcha: "", // 生成的验证码
      };
    },
    mounted() {
      this.refreshCaptcha(); // 初始化验证码
    },
    methods: {
      // 生成随机验证码
      generateCaptcha() {
        const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        let captcha = "";
        for (let i = 0; i < 4; i++) {
          captcha += chars[Math.floor(Math.random() * chars.length)];
        }
        return captcha;
      },
      // 刷新验证码
      refreshCaptcha() {
        this.captcha = this.generateCaptcha();
        this.drawCaptcha();
      },
      // 将验证码渲染到 canvas
      drawCaptcha() {
        const canvas = this.$refs.captchaCanvas;
        const ctx = canvas.getContext("2d");
  
        // 清空画布
        ctx.clearRect(0, 0, canvas.width, canvas.height);
  
        // 设置背景色
        ctx.fillStyle = "#f0f0f0";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
  
        // 添加背景噪点
        for (let i = 0; i < 50; i++) {
          ctx.fillStyle = `rgba(${Math.random() * 255}, ${Math.random() * 255}, ${Math.random() * 255}, 0.5)`;
          ctx.fillRect(Math.random() * canvas.width, Math.random() * canvas.height, 2, 2);
        }
  
        // 添加干扰线
        for (let i = 0; i < 5; i++) {
          ctx.strokeStyle = `rgba(${Math.random() * 255}, ${Math.random() * 255}, ${Math.random() * 255}, 0.7)`;
          ctx.beginPath();
          ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
          ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
          ctx.stroke();
        }
  
        // 绘制验证码字符
        for (let i = 0; i < this.captcha.length; i++) {
          const char = this.captcha[i];
          ctx.font = "24px Arial";
          ctx.fillStyle = `rgba(${Math.random() * 255}, ${Math.random() * 255}, ${Math.random() * 255}, 1)`;
          ctx.save();
          ctx.translate(20 + i * 20, 30);
          ctx.rotate((Math.random() - 0.5) * 0.4); // 随机旋转角度
          ctx.fillText(char, 0, 0);
          ctx.restore();
        }
      },
      // 验证传入的验证码是否正确
      validateCaptcha(input) {
        return input.toLowerCase() === this.captcha.toLowerCase();
      },
    },
  };
  </script>
  
  <style>
  .captcha-container {
    display: inline-block;
  }
  .captcha-canvas {
    border: 1px solid #ccc;
    border-radius: 4px;
    cursor: pointer;
  }
  </style>


// WEBPACK FOOTER //
// src/components/apply/check.vue